<template>
  <v-container>
    <div class="BGImg"></div>
    <v-row no-gutters justify="center" class="mt-4 mb-4">
      <v-col sm="12" lg="6" md="6" xl="6" cols="12">
        <v-card color="transparent" dark elevation="0" class="pl-4 pr-4 pt-4">
          <v-col class="text-start">
            <h1 class="PlayFairFont">
              CONTACT US
            </h1>
            <span>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
              </span>

            <v-row class="mt-8" no-gutters justify="start">
              <v-icon class="mr-4">mdi-phone-outline</v-icon>
              <span>+9471 580 8080</span>
            </v-row>

            <v-row align="start" class="mt-3" no-gutters justify="start">
              <v-icon class="mr-4">mdi-map-marker-outline</v-icon>
              <span>
                145/1,<br>
                HighLevel Rd,<br>
                Pannipitiya,<br>
                Sri Lanka.
              </span>
            </v-row>

            <v-row class="mt-3" no-gutters justify="start">
              <v-icon class="mr-4">mdi-email-outline</v-icon>
              <span>info@wildceylon.com</span>
            </v-row>
          </v-col>
        </v-card>
      </v-col>
      <v-col sm="12" lg="5" md="5" xl="5" cols="12">
        <v-card class="pl-4 pr-4 pt-4">
          <ContactForm/>
        </v-card>
      </v-col>
    </v-row>

  </v-container>
</template>

<script>
import ContactForm from "@/components/ContactForm";

export default {
  name: "ContactUs",
  components: {ContactForm}
}
</script>

<style scoped>
.BGImg {
  position: absolute;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100%;
  background-image: url("/assets/packages_bg.png");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.PlayFairFont {
  font-family: 'Playfair Display', serif !important;
}
</style>
